import React, { useState } from 'react';
import { CheckBox } from '../../../styles/commonStyle';

interface TermsSocProps {
    termsContent: string;
    isChecked: boolean;
    onCheckChange: (checked: boolean) => void;
    title?: string;
}

const TermsSoc: React.FC<TermsSocProps> = ({
    termsContent,
    isChecked,
    onCheckChange,
    title = "약관 동의"
}) => {
    const [openIdx, setOpenIdx] = useState<number>(-1);

    const handleHeaderClick = () => {
        setOpenIdx(openIdx === 0 ? -1 : 0);
    };

    const handleLabelClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        onCheckChange(!isChecked);
        setOpenIdx(openIdx === 0 ? -1 : 0);
    };

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation();
        onCheckChange(e.target.checked);
    };

    return (
        <div style={{ marginTop: "20px", width: "100%", border: "1px solid #ddd", borderRadius: "6px", background: "#fff" }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 20px",
                    cursor: "pointer",
                    fontSize: "18px",
                    fontWeight: "400"
                }}
                onClick={handleHeaderClick}
            >
                <div style={{ display: "flex", alignItems: "center", flex: 1, gap: "10px" }}>
                    <CheckBox
                        type="checkbox"
                        id="terms"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                    />
                    <label 
                        htmlFor="terms"
                        onClick={handleLabelClick}
                        style={{ cursor: "pointer", fontSize: "14px", fontWeight: "500", letterSpacing: "-0.5px" }}
                    >
                        {title}
                    </label>
                </div>
                <span style={{
                    alignSelf: "center",
                    marginLeft: "auto",
                    fontSize: "1.5rem",
                    transition: "transform 0.2s",
                    transform: openIdx === 0 ? "rotate(180deg)" : "rotate(0deg)"
                }}>
                    ⌃
                </span>
            </div>
            {openIdx === 0 && (
                <div style={{
                    borderTop: "1px solid #ddd",
                    maxHeight: "300px",
                    overflowY: "auto",
                    padding: "20px",
                    fontSize: "14px",
                    color: "#777777",
                    background: "#fff"
                }}>
                    <div dangerouslySetInnerHTML={{ __html: termsContent || '' }} />
                </div>
            )}
        </div>
    );
};

export default TermsSoc;
